import React, { useState, useEffect } from 'react';

const About = ({ language }) => {
  const content = {
    en: {
      title: "About Bitcoin Buddy",
      question1: "What is Bitcoin Buddy?",
      introAnswer1: "Welcome to Bitcoin Buddy! 🎉 We're here to help you explore the fascinating world of Bitcoin. Whether you're just starting out or have been around for a while, Bitcoin Buddy is your friendly companion, ready to answer your questions and guide you through in a supportive environment.",
      question2: "How do you use Bitcoin Buddy?",
      answer2: "Just type in your Bitcoin-related questions, and Anna, our friendly AI Bitcoin expert, will provide you with thoughtful and insightful answers. 🤓",
      question3: "Who is Anna?",
      buddies: [
        {
          name: 'Anna',
          image: '/images/anna_fischer.jpg',
          bio: `Anna is your friendly AI companion with deep expertise in Bitcoin and related technologies. She is designed to make complex Bitcoin topics easy to understand, offering clear and engaging explanations. Whether you're curious about the technical details or the broader implications of Bitcoin, Anna is here to guide you with a calm and supportive approach. 💻`
        }
      ],
      question4: "How can you support Bitcoin Buddy?",
      answer4: "Enjoying Bitcoin Buddy? Help us keep the momentum going! 🙌 Your donations help us maintain the platform and continue the Bitcoin conversation. Every contribution goes towards developing new features and covering infrastructure costs. 💪",
      contact: "Have questions, feedback, or interested in becoming a sponsor? Reach out to us at <a href='mailto:bitcoinbuddychat@gmail.com'><u>bitcoinbuddychat@gmail.com</u></a>. We'd love to hear from you! 💬 You can also follow us on X <a href='https://x.com/BTCBuddyChat' target='_blank'><u>@BTCBuddyChat</u></a> for the latest updates."
    },
    de: {
      title: "Über Bitcoin Buddy",
      question1: "Was ist Bitcoin Buddy?",
      introAnswer1: "Willkommen bei Bitcoin Buddy! 🎉 Wir helfen dir, die faszinierende Welt von Bitcoin zu erkunden. Egal, ob du gerade erst anfängst oder schon länger dabei bist, Bitcoin Buddy ist dein freundlicher Begleiter, bereit, deine Fragen zu beantworten und dich in einer unterstützenden Umgebung zu begleiten.",
      question2: "Wie nutzt man Bitcoin Buddy?",
      answer2: "Gib einfach deine Bitcoin-Fragen ein, und Anna, unsere freundliche KI und Bitcoin-Expertin, wird dir mit durchdachten und aufschlussreichen Antworten helfen. 🤓",
      question3: "Wer ist Anna?",
      buddies: [
        {
          name: 'Anna',
          image: '/images/anna_fischer.jpg',
          bio: `Anna ist deine freundliche KI-Begleiterin mit tiefem Fachwissen in Bitcoin und verwandten Technologien. Sie wurde entwickelt, um komplexe Bitcoin-Themen leicht verständlich zu machen und bietet klare und ansprechende Erklärungen. Egal, ob du an den technischen Details oder den breiteren Auswirkungen von Bitcoin interessiert bist, Anna ist hier, um dich mit einer ruhigen und unterstützenden Herangehensweise zu führen. 💻`
        }
      ],
      question4: "Wie kannst du Bitcoin Buddy unterstützen?",
      answer4: "Gefällt dir Bitcoin Buddy? Hilf uns, die Begeisterung aufrechtzuerhalten! 🙌 Deine Spenden helfen uns, die Plattform zu pflegen und die Bitcoin-Gespräche am Laufen zu halten. Jede Spende fließt in die Entwicklung neuer Funktionen und die Deckung der Infrastrukturkosten. 💪",
      contact: "Hast du Fragen, Feedback oder Interesse daran, Sponsor zu werden? Kontaktiere uns unter <a href='mailto:bitcoinbuddychat@gmail.com'><u>bitcoinbuddychat@gmail.com</u></a>. Wir würden uns freuen, von dir zu hören! 💬 Folge uns auch auf X <a href='https://x.com/BTCBuddyChat' target='_blank'><u>@BTCBuddyChat</u></a> für die neuesten Updates."
    }
  };

  const langContent = content[language];
  const [typingStep, setTypingStep] = useState(0);
  const [displayedMessages, setDisplayedMessages] = useState([]);

  useEffect(() => {
    if (typingStep < 10) {
      const timeout = setTimeout(() => {
        setDisplayedMessages((prev) => [...prev, typingStep]);
        setTypingStep((prev) => prev + 1);
      }, 1000);
      return () => clearTimeout(timeout);
    }
  }, [typingStep]);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      alert("Address copied to clipboard!");
    });
  };

  const getMessageContent = (step) => {
    switch (step) {
      case 0:
        return <div className="message-bubble user-message">{langContent.question1}</div>;
      case 1:
        return <div className="message-bubble assistant-message">{langContent.introAnswer1}</div>;
      case 2:
        return <div className="message-bubble user-message">{langContent.question2}</div>;
      case 3:
        return <div className="message-bubble assistant-message">{langContent.answer2}</div>;
      case 4:
        return <div className="message-bubble user-message">{langContent.question3}</div>;
      case 5:
        return (
          <div className="message-bubble assistant-message flex flex-col items-center">
            <div className="grid grid-cols-1 gap-4 mt-4">
              <div className="text-center">
                <img src={langContent.buddies[0].image} alt={langContent.buddies[0].name} className="w-24 h-24 rounded-full mx-auto" />
                <h3 className="text-lg font-semibold text-white mt-2">{langContent.buddies[0].name}</h3>
                <p className="text-gray-300 mt-2">{langContent.buddies[0].bio}</p>
              </div>
            </div>
          </div>
        );
      case 6:
        return <div className="message-bubble user-message">{langContent.question4}</div>;
      case 7:
        return (
          <div className="message-bubble assistant-message">
            <p className="text-white text-center mb-4">
              {langContent.answer4}
            </p>
          </div>
        );
      case 8:
        return (
          <div className="message-bubble assistant-message flex flex-col items-center">
            <div className="qr-code-grid grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
              <div className="qr-code-item text-center cursor-pointer" onClick={() => copyToClipboard("buddy@walletofsatoshi.com")}>
                <img src="/images/wallet_satoshi_lightning.jpg" alt="Bitcoin (Lightning) QR Code" className="w-48 h-48 mx-auto" />
                <p className="mt-2 text-white"><i className="fas fa-bolt"></i> Bitcoin (Lightning)</p>
              </div>
              <div className="qr-code-item text-center cursor-pointer" onClick={() => copyToClipboard("bc1qych4mygtkrtrgtamge0x0vxu8uszw4hedf83yn")}>
                <img src="/images/wallet_satoshi_bitcoin.jpg" alt="Bitcoin (On-Chain) QR Code" className="w-48 h-48 mx-auto" />
                <p className="mt-2 text-white"><i className="fas fa-bitcoin"></i> Bitcoin (On-Chain)</p>
              </div>
            </div>
          </div>
        );
      case 9:
        return (
          <div className="message-bubble assistant-message flex flex-col items-center">
            <p className="text-white text-center" dangerouslySetInnerHTML={{ __html: langContent.contact }}></p>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <main className="flex flex-col flex-grow container mx-auto p-4 mt-16">
      <div className="chat-box flex-grow overflow-y-auto mb-4 mt-4 relative">
        {displayedMessages.map((step) => (
          <React.Fragment key={step}>
            {getMessageContent(step)}
          </React.Fragment>
        ))}
      </div>
    </main>
  );
}

export default About;
